export default __webpack_public_path__ + "static/media/mackbook.f5d17891.png";